import InterfaceAsesmenRalan from "../apiInterface/InterfaceAsesmenRalan";
import ErrorAlert from "@/utility/ErrorAlert";

class DataAsesmenRalan {
  // async getDataAsesmenRalan(unit, reg) {
  //   let dt: any
  //   await InterfaceAsesmenRalan.getAsesmenRalan(unit, reg).then((response) => {
  //     dt = response.data
  //   })
  //     .catch((e) => {
  //       dt = e.response
  //       ErrorAlert.showSnackAlert(e, "Asesmen Awal Ralan")
  //     });
  //   return dt
  // }

  async getDataAsesmenAwalRalan(unit, reg) {
    let dt: any;
    await InterfaceAsesmenRalan.getAsesmenAwalRalan(unit, reg)
      .then(response => {
        dt = response.data;
        console.log("data", dt);
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Asesmen Awal Ralan");
      });
    return dt;
  }

  // async getDataAsesmenRalanByID(id) {
  //   let dt: any
  //   await InterfaceAsesmenRalan.getAsesmenRalanByID(id).then((response) => {
  //     dt = response.data
  //   })
  //     .catch((e) => {
  //       dt = e.response
  //       ErrorAlert.showSnackAlert(e, "Asesmen Awal Ralan")
  //     });
  //   return dt
  // }

  // async getCetakPdfAsesmenRalan(id) {
  //   let dt: any
  //   await InterfaceAsesmenRalan.cetakPdfAsesmenRalan(id).then((response) => {
  //     dt = response.data
  //   })
  //     .catch((e) => {
  //       dt = e.response
  //       ErrorAlert.showSnackAlert(e, "Cetak Asesmen Awal Ralan")
  //     });
  //   return dt
  // }
  async getCetakPdfAsesmenAwalRalan(id) {
    let dt: any;
    await InterfaceAsesmenRalan.cetakPdfAsesmenAwalRalan(id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Cetak Asesmen Awal Ralan");
      });
    return dt;
  }

  async getDataStatusAsesmenRalan(unitId, rm, registerId) {
    let dt: any;
    await InterfaceAsesmenRalan.checkStatusAsesmenRalan(unitId, rm, registerId)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Status Asesmen Awal Ralan");
      });
    return dt;
  }

  // async saveDataAsesmenRalan(
  //   reg,
  //   rm,
  //   unit_id,
  //   user_id,
  //   dokter_id,
  //   perawat_id,
  //   kronis
  // ) {
  //   let dt: object = {}
  //   await InterfaceAsesmenRalan.saveAsesmenRalan(
  //     reg,
  //     rm,
  //     unit_id,
  //     user_id,
  //     dokter_id,
  //     perawat_id,
  //     kronis
  //   ).then((response) => {
  //     dt = response.data
  //   })
  //     .catch((e) => {
  //       dt = e.response
  //       ErrorAlert.showErrorAlert(e)
  //     });
  //   return dt
  // }

  // async editDataAsesmenRalan(
  //   id,
  //   reg,
  //   rm,
  //   unit_id,
  //   user_id,
  //   dokter_id,
  //   perawat_id,
  //   kronis
  // ) {
  //   let dt: object = {}
  //   await InterfaceAsesmenRalan.editAsesmenRalan(
  //     id,
  //     reg,
  //     rm,
  //     unit_id,
  //     user_id,
  //     dokter_id,
  //     perawat_id,
  //     kronis
  //   ).then((response) => {
  //     dt = response.data
  //   })
  //     .catch((e) => {
  //       dt = e.response
  //       ErrorAlert.showErrorAlert(e)
  //     });
  //   return dt
  // }

  async saveDataAsesmenRalanKeperawatan(reg, rm, unit_id, user_id, param) {
    let dt: object = {};
    await InterfaceAsesmenRalan.saveAsesmenRalanKeperawatan(
      reg,
      rm,
      unit_id,
      user_id,
      param
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async editDataAsesmenRalanKeperawatan(id, reg, rm, unit_id, user_id, param) {
    let dt: object = {};
    await InterfaceAsesmenRalan.editAsesmenRalanKeperawatan(
      id,
      reg,
      rm,
      unit_id,
      user_id,
      param
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async saveDataAsesmenRalanMedis(reg, rm, unit_id, user_id, param) {
    let dt: object = {};
    await InterfaceAsesmenRalan.saveAsesmenRalanMedis(
      reg,
      rm,
      unit_id,
      user_id,
      param
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async editDataAsesmenRalanMedis(id, reg, rm, unit_id, user_id, param) {
    let dt: object = {};
    await InterfaceAsesmenRalan.editAsesmenRalanMedis(
      id,
      reg,
      rm,
      unit_id,
      user_id,
      param
    )
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }
}

export default new DataAsesmenRalan();
